/* eslint-disable react/jsx-key */
import React, { Component } from 'react'
import { Input, Button, InputNumber, Modal, Select, message } from 'antd'
import R from 'ramda'
import { conCodes, fixDescriptionValue } from '../../utils'
import MultiCauseCodePropmt from '../../MultiCauseCode'
import styled from 'styled-components'

const Label = styled.td`
  text-align: end;
  align-self: center;
`

class LowerTablePrompt extends Component {
  state = {
    ...this.props.tableRowData,
    ...this.props.getExpandedKeys(
      [this.props.unitCode],
      this.props.tableRowData && this.props.tableRowData.causeCode
    ),
  }

  openTableCauseCodePrompt = d => this.setState({ tableCauseCodeDialog: d })

  onTableCauseCodeTreeCancel = causeCodeKeyValues => {
    this.setState({
      causeCodeKeyValues,
      tableCauseCodeDialog: false,
    })
  }

  onTableCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    this.setState({
      tableCauseCodeDialog: false,
      causeCodeKeyValues,
      causeCodeValues,
      causeCode: causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : this.state.causeCode,
    })
  }

  handleChange = ({ name, value }) => {
    this.setState({
      [name]: value,
    })
  }

  render() {
    const {
      ampCodeMap,
      failCodeMap,
      setLowerTableData,
      openLowerTablePrompt,
      tableMode,
      unitCode,
      // eslint-disable-next-line no-unused-vars
      contribConditionList = [],
    } = this.props
    const {
      failCode,
      ampCode,
      causeCode,
      conCode,
      description,
      tableCauseCodeDialog,
      extension = {},
    } = this.state
    // eslint-disable-next-line no-unused-vars
    const { eventTypeExternal } = extension
    if (!eventTypeExternal) {
      this.handleChange({
        name: 'extension',
        value: { ...extension, eventTypeExternal: '0' },
      })
    }

    const failAmpCodeOption = R.compose(
      // R.map(([key, text]) => ({ key: key, text, value: key })),
      R.map(([key, text]) => <Select.Option value={key}>{text}</Select.Option>),
      R.sortBy(([_, text]) => text.toLowerCase()),
      R.toPairs
    )

    // const nullFailAmpCodeOption = { key: '', value: '', text: '' }

    return [
      <Modal
        visible={this.props.lowerTableDialog}
        title={tableMode === 'new' ? 'New Data' : 'Edit Data'}
        footer={[
          <Button
            type="primary"
            onClick={() => {
              if (!causeCode || ('' + causeCode || '').trim().length <= 0) {
                message.warning('Cause Code is required.')
                return
              }

              setLowerTableData &&
                setLowerTableData(false, {
                  causeCode: causeCode || '',
                  conCode: conCode || '',
                  failCode: failCode || '',
                  ampCode: ampCode || '',
                  description: fixDescriptionValue(
                    description || '',
                    true,
                    true
                  ),
                  extension: extension || {},
                })
            }}
          >
            {tableMode === 'new' ? 'Add' : 'Update'}
          </Button>,
          <Button
            onClick={() => {
              openLowerTablePrompt && openLowerTablePrompt(false)
            }}
          >
            Cancel
          </Button>,
        ]}
        bodyStyle={{
          display: 'grid',
          gridTemplateColumns: '250px 1fr',
          gridRowGap: '5px',
          gridColumnGap: '10px',
          padding: '10px',
          overflowX: 'auto',
        }}
        width="1000px"
      >
        <Label>{'Cause Code '}</Label>
        <div>
          <InputNumber
            min={0}
            name="causeCode"
            value={causeCode || ''}
            onChange={value => this.handleChange({ name: 'causeCode', value })}
          />

          <Button
            onClick={() => {
              if (
                this.props.unit === undefined ||
                this.props.utility === undefined
              ) {
                message.info('Please, Select Utility and Unit')
                return
              }
              this.openTableCauseCodePrompt(true)
            }}
            style={{ marginLeft: '10px' }}
          >
            Select Cause Code
          </Button>
        </div>
        <Label>{'Contribution Code: '}</Label>
        <Select
          allowClear
          name="conCode"
          value={(conCode && conCode.trim()) || ''}
          onChange={value => this.handleChange({ name: 'conCode', value })}
        >
          {conCodes.map(e => (
            <Select.Option value={e.value}>
              {e.value} - {e.text}
            </Select.Option>
          ))}
        </Select>

        <Label>{'Contributing Operating Condition: '}</Label>
        <Select
          style={{ width: '100%' }}
          key="eventTypeExternal"
          value={eventTypeExternal}
          // placeholder="Contributing Operating Condition"
          name="eventTypeExternal"
          onChange={value => {
            if (value === ' ') {
              this.handleChange({
                name: 'extension',
                value: { ...extension, eventTypeExternal: '0' },
              })
            } else
              this.handleChange({
                name: 'extension',
                value: { ...extension, eventTypeExternal: value },
              })
          }}
          selection
        >
          {/* <Select.Option key="[]" value=" " style={{ height: '20px' }} /> */}

          {R.sortBy(R.prop('code'), contribConditionList).map(e => (
            <Select.Option key={e.code} value={e.code}>
              {e.code} - {e.description}
            </Select.Option>
          ))}
        </Select>

        <Label>{'Fail Code '}</Label>
        <Select
          allowClear
          Label="Fail Code:"
          name="failCode"
          options={failAmpCodeOption(failCodeMap)}
          value={(failCode && failCode.trim()) || ''}
          onChange={value => this.handleChange({ name: 'failCode', value })}
        >
          {failAmpCodeOption(failCodeMap)}
        </Select>
        <Label>{'Amplification Code: '}</Label>
        <Select
          allowClear
          Label="Amplification Code:"
          name="ampCode"
          value={(ampCode && ampCode.trim()) || ''}
          onChange={value => this.handleChange({ name: 'ampCode', value })}
        >
          {failAmpCodeOption(ampCodeMap)}
        </Select>
        <Label>Description:</Label>
        <Input.TextArea
          fluid
          Label="Description"
          name="description"
          value={(description && description) || ''}
          onChange={e => {
            this.handleChange({
              name: 'description',
              value: fixDescriptionValue(e.target.value),
            })
          }}
        />
      </Modal>,
      tableCauseCodeDialog && (
        <MultiCauseCodePropmt
          key="card97tablecausecodeprompt"
          // style={{ ...inlineStyle }}
          // checkable={false}
          visibleDialog={this.state.tableCauseCodeDialog}
          onDialogClose={this.onTableCauseCodeDialogClose}
          onCancelAction={this.onTableCauseCodeTreeCancel}
          // defaultExpandedKeys={causeCode ? causeCode.selectedKeys : []}
          // defaultExpandedKeys={this.state.causeCodeKeyValues ? this.state.causeCodeKeyValues : []}
          // selectedKeys={this.state.causeCodeKeyValues ? this.state.causeCodeKeyValues : []}
          // selectedValues={this.state.causeCodeValues || []}
          selectedKeys={this.state.causeCodeKeyValues}
          selectedValues={this.state.causeCodeValues}
          unitCodes={[unitCode]}
          multiple={false}
          checkable={false}
          selectable
          causeCodeValues={[causeCode]}
          causeCodeList={this.props.causeCodeList}
        />
      ),
    ]
  }
}

export default LowerTablePrompt
